var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevealification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 546.13 546.13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m252.92 67.973c-69.437 88.745-137.41 151.38-240 206.52 94.68 46.064 166.76 115.7 239.38 202.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.35 107.93c48.117 47.663 62.755 249.38 0.98804 333.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.06 197.04c-133.95 58.622-48.592 144.01-5.2495 143.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.14 188.22 154.41-54.078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.61 273.23 153.19 0.78624"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.19 357.92 151.32 53.129"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevealification);
export default __webpack_public_path__ + "static/media/revealification.e1a18b2b9abdeee0de13dcc0bb37e6fb.svg";
export { ForwardRef as ReactComponent };